import React from 'react'
import { Flex, PopoverMenu, SingleMenuItem, Text, TextVariant } from '@mprolab/uikit'
import styled, { useTheme } from 'styled-components'
import { Grid } from '@mui/material'
import { ChevronDown } from 'react-feather'
import { ContractMenuItem } from '../types'

const Box = styled(Flex)`
  cursor: pointer;
  padding: 8px;
  background: ${({ theme }) => theme.colors.gray10};
  border-radius: 8px;
  height: 56px;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s ease-in-out;
  :hover {
    background: ${({ theme }) => theme.colors.gray9};
  }
`

interface SelectContractPopoverProps {
  title: string
  menuItems: ContractMenuItem[]
  onSelect: (item: SingleMenuItem) => void
  contract: ContractMenuItem
}

const SelectContractPopover: React.FC<SelectContractPopoverProps> = ({ title, menuItems, onSelect, contract }) => {
  const { colors } = useTheme()

  return (
    <Grid item xs={12} sm={5} md={5}>
      <Text variant={TextVariant.TEXT_XS_BOLD} color={colors.white} mb="8px">
        {title}
      </Text>
      <PopoverMenu
        customPaperStyle={{ width: 226 }}
        menuItems={menuItems}
        onItemClick={onSelect}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
      >
        <Box>
          <Flex gap="16px" alignItems="center">
            {contract?.icon}
            <Text clickable variant={TextVariant.BODY_DEFAULT_BOLD}>
              {contract?.label}
            </Text>
          </Flex>
          <ChevronDown color={colors.white} />
        </Box>
      </PopoverMenu>
    </Grid>
  )
}

export default SelectContractPopover
